/**
 * This is a temporary solution to override the claim name for the following claims:
 */
export const nameOverrides: Record<string, string> = {
    'Transfer, Create': 'Create Transfer',
    'Wire, Domestic, Create Wire': 'Create Domestic Wire Payment',
    'Wire, Domestic, Create Wire Template': 'Create Wire Template',
    'Wire, Domestic, Create Creditor': 'Create Creditor',
    'Wire, International, Create Creditor': 'Create International Wire Creditor',
    'Wire, International, Edit Creditor': 'Edit International Wire Creditor',
    'Wire, International, Delete Creditor': 'Delete International Wire Creditor',
    'Wire, International, Approve Creditor': 'Approve International Wire Creditor',
    'Wire, International, Create Wire': 'Create International Wire Payment',
    'Wire, International, Create Wire Template': 'Create International Wire Template',
    'Wire, International, Edit Wire Template': 'Edit International Wire Template',
    'Wire, International, Delete Wire Template': 'Delete International Wire Template',
    'Wire, International, Approve Wire Template': 'Approve International Wire Template',
};
